module.exports = __webpack_public_path__ + "img/Vertex_white.0825e130.svg";